import { BrainCircuit } from "lucide-react"; // Import the Zap icon

// export default function Logo() {
//   return (
//     <div className="flex items-center space-x-3 mb-8">
//       <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
//         <span className="text-white font-bold text-xl">O</span>
//       </div>
//       <div>
//         <h1 className="text-2xl font-bold text-gray-900">Onboarding Business</h1>
//         <p className="text-sm text-gray-500">Voice AI  Solutions</p>
//       </div>
//     </div>
//   );
// }

export default function Logo() {
  return (
    <div className="flex items-center space-x-3 mb-8">
      <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
        {/* Replaced 'O' with the Zap icon */}
        <BrainCircuit size={24} className="text-white" />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Onboarding Business</h1>
        <p className="text-sm text-gray-500">Voice AI Solutions</p>
      </div>
    </div>
  );
}
